module.exports = __webpack_public_path__ + "img/ice.a874fac3.png";